import React from 'react';
import { BrowserRouter as Router, Route } from "react-router-dom";
import {
  InvoicePage,
  WithdrawMoneyPage,
  PromotionPage,
  MessagePage,
  AgentPage,
  TaobaoDomainChangePage,
  TaobaoPage,
  MultiDomainPage,
  ShortUrlPage
} from './pages';
import './App.css';
import { LocaleProvider } from 'antd';
import zh_CN from 'antd/lib/locale-provider/zh_CN';

const App = () => (
  <LocaleProvider locale={zh_CN}>
    <Router>
      <React.Fragment>
        <Route exact path="/" rediect="/v5/invoice" component={InvoicePage} />
        <Route path="/v5/invoice" component={InvoicePage} />
        <Route path="/v5/withdraw" component={WithdrawMoneyPage}/>
        <Route path="/v5/promotion" component={PromotionPage} />
        <Route path="/v5/message" component={MessagePage} />
        <Route path="/v5/agent" component={AgentPage} />
        <Route path="/v5/tkPlugin" component={TaobaoDomainChangePage} />
        <Route path="/v5/taobao" component={TaobaoPage} />
        <Route path="/v5/multi-domain" component={MultiDomainPage} />
        <Route path="/v5/short-url" component={ShortUrlPage} />
      </React.Fragment>
    </Router>
  </LocaleProvider>
);

export default App;
